export default class AuthorModal {
    constructor(author, mod) {
        this.xMousePos = 0;
        this.yMousePos = 0;

        this.fetchDomElements(author, mod);
        setTimeout(()=>{
            this.values = this.getValuesOfHiddenAuthorElement(this.domElements.dialog.querySelectorAll('.modal-content')[0], this.domElements.authorModal);
            this.registerEventListeners();
        },100);
    }

    fetchDomElements(author, mod) {
        // let mod = document.getElementById('authorModal');
        this.domElements = {
            authorToggleBtns: author,
            // authorToggleBtns: document.querySelectorAll('.toggleLinkAuthor'),
            authorModal: mod,
            dialog: mod.querySelectorAll('.modal-dialog')[0],
        };
    }

    registerEventListeners(){
        this.domElements.authorToggleBtns.forEach((element) => {
            element.addEventListener('click', (e) => this.onAuthorClick(e));
        });

        $(document).on('hide.bs.modal', '#' + this.domElements.authorModal.id, () => this.setDialogTranslateAtClose("translate("+((this.values[3] + (this.values[1] / 2) - this.xMousePos) * -1)+"px,"+((this.values[2] + (this.values[0] / 2) - this.yMousePos) * -1)+"px)") );
        // $(document).on('hide.bs.modal','#authorModal', () => this.setDialogTranslateAtClose("translate("+((this.values[3] + (this.values[1] / 2) - this.xMousePos) * -1)+"px,"+((this.values[2] + (this.values[0] / 2) - this.yMousePos) * -1)+"px)") );
    }

    onAuthorClick(e) {
        e.preventDefault();
        //window.scroll(0,0);
        this.xMousePos = e.pageX;
        this.yMousePos = e.pageY - window.scrollY;

        document.body.classList.toggle('authorOpen');
        this.setDialogTranslate("translate("+((this.values[3] + (this.values[1] / 2) - this.xMousePos) * -1)+"px,"+((this.values[2] + (this.values[0] / 2) - this.yMousePos) * -1)+"px)");
    }

    setDialogTranslate(trans) {
        let scaleAdd = ' scale(0.1)';

        if(document.body.classList.contains('authorOpen')){
            this.domElements.dialog.querySelectorAll('.modal-content')[0].style.transform = trans + scaleAdd;
            scaleAdd = ' scale(1)';
            trans = "translate(0px,0px)";
            setTimeout(() => this.setDialogTranslateWithScale(trans,scaleAdd) , 320);
        }
        else{
            this.domElements.dialog.querySelectorAll('.modal-content')[0].style.transform = trans + scaleAdd;
        }
    }

    setDialogTranslateWithScale(trans,scaleAdd) {
        this.domElements.dialog.querySelectorAll('.modal-content')[0].style.transform = trans + scaleAdd;
    }

    setDialogTranslateAtClose(trans) {
        let scaleAdd = ' scale(0.1)';
        document.body.classList.remove('authorOpen');
        this.setDialogTranslateWithScale(trans,scaleAdd);
    }

    getValuesOfHiddenAuthorElement(scaled,disp) {
        var el_style      = window.getComputedStyle(disp),
            el_display    = el_style.display,
            el_visibility = el_style.visibility,
            el_max_height = el_style.maxHeight.replace('px', '').replace('%', ''),
            el_transform  = el_style.transform,

            el2_style     = window.getComputedStyle(scaled),
            el2_transform = el2_style.transform,

            wanted_height = 0,
            wanted_width  = 0;


        disp.style.visibility = 'hidden';
        disp.style.display    = 'block';
        disp.style.transform  = 'scale(1)';

        scaled.style.transform = 'scale(1)';

        wanted_height = scaled.offsetHeight;
        wanted_width  = scaled.offsetWidth;

        var scaledRect = scaled.getBoundingClientRect();

        // reverting to the original values
        disp.style.display    = el_display;
        disp.style.visibility = el_visibility;
        disp.style.transform  = el_transform;

        scaled.style.transform  = el2_transform;

        let values = [wanted_height,wanted_width,scaledRect.top,scaledRect.left];

        return values;
    }
}
